<template>

  <div class="overall-bg pt-0">
    <b-form @submit.prevent="IsDraftSubmit(0)">
      <b-container class="container-class">
        <b-row class="stepperdiv">
          <b-col lg="6" md="6" sm="6" cols="2">
            <BackToMasters :goback="$router.back"></BackToMasters>
            <p v-if="paramValue == 'PO'">
              <Headerlayout :headertext="$t('PurchaseOrder.title')" :contenttext="$t('PurchaseOrder.contents')">
              </Headerlayout>
            </p>
            <p v-if="paramValue == 'POAmendment'">
              <Headerlayout :headertext="$t('PurchaseAmmendment.title')"
                :contenttext="$t('PurchaseAmmendment.contents')">
              </Headerlayout>
            </p>
          </b-col>
          <b-col lg="6" md="6" sm="6" cols="2" class="d-flex flex-row-reverse">
            <div class="poaction">
              <div class="savedraftbtn me-2 " v-if="route.query.param == 'PO'">
                <span v-if="SaveLoader">Loading...</span>
                <p v-else @click="IsDraftSubmit(1)">Save as draft</p>
              </div>

              <Footer class="py-2" :goback="$router.back" :loading="SaveLoader" />
            </div>

          </b-col>
        </b-row>
        <SkeletonForm v-show="loadingforms" :loading="loadingforms" />
        <div class="row form-white-bg" v-show="!loadingforms">
          <b-row>
            <div class="mb-4 d-flex gap-4">
              <div v-for="item in menuarray" class='d-flex'>
                <RadioButton v-model="consumeOrService" inputId="ingredient1" name="pizza" :value="item?.POType"
                  @click="GetCode(item?.EntityId)" :disabled="codeStatus" />
                <label for="ingredient1" class="ms-2">{{
                  item["SubMenuName"]
                }}</label>
              </div>

            </div>
          </b-row>
          <b-row>
            <b-col lg="2" md="4" sm="6">
              <div class="field">
                <label> {{ DocNoObj.Label1 }}</label>
                <p>{{ requestForm.DocNo }}</p>
              </div>
            </b-col>
            <b-col lg="2" md="4" sm="6" v-if="DocNoObj.Label2HideAndShow == true">
              <div class="field">
                <label> {{ DocNoObj.Label2 }}</label>

                <p>{{ requestForm.RefNo }}</p>
              </div>
            </b-col>
            <b-col lg="3" md="4" sm="6">
              <div class="field">

                <Datepicker dateformat="dd-mm-yy" :label="$t('PO.POCreation.podate')" v-model="requestForm.DocDate"
                  :disabled="true" />
              </div>
            </b-col>

            <b-col lg="3" md="4" sm="6">
              <!-- Medway -->
              <div class="field">
                <StoreDropDown :storeFilterStatus="1" :label="$t('PO.POCreation.store')" name="Store" id="Store"
                  v-model="StoreDropdown.ToStoreBrMapId" :showClear='false'
                  @update:modelValue="() => { SelectStore(StoreDropdown.ToStoreBrMapId), StoreOnChange(StoreDropdown.ToStoreBrMapId) }"
                  :rules="{ required: true }" :required-icon="true" :disabled="StoreDropdownDisable"
                  @StoreOptions="StoreOptionsFun" />
              </div>
              <!-- Aravind -->
              <!-- <div class="field">
                <StoreDropDown :storeFilterStatus="2" :label="$t('PO.POCreation.store')" name="Store" id="Store"
                  v-model="StoreDropdown.ToStoreBrMapId" :showClear='false'
                  @update:modelValue="() => { SelectStore(StoreDropdown.ToStoreBrMapId), StoreOnChange(StoreDropdown.ToStoreBrMapId) }"
                  :rules="{ required: true }" :required-icon="true" :disabled="StoreDropdownDisable" @StoreOptions="StoreOptionsFun"/>
              </div> -->
            </b-col>
            <b-col lg="3" md="4" sm="6" cols="12" class="d-flex">
              <div class="field">
                <label>{{ $t("Request.uploadquotation") }}</label>
                <input type="file" :multiple="true" id="actual-btn" @change="handleChangedocument" ref="fileInput"
                  style="display: none;" />
                <label id="custom-btn" for="actual-btn" class="flbtn">
                  <i class="pi pi-upload" style="color: slateblue"></i>
                  Choose File</label>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="3" md="4" sm="6" cols="12" class="d-flex" v-for="item in uploadedTableList">
              <div class="fileuploadcard my-2" :title="item.fileName">
                <div>
                  <p class="filenametxt">{{ item.fileName }}</p>
                  <div class="blue-txt" id="file-name" @click="fileviewer(item.fullPath)">
                    view </div>
                </div>
                <DeleteIcon @click="fileuploadDelete(item)" />
              </div>
            </b-col>
          </b-row>
          <!-- <div class="mb-4 d-flex gap-4">
            <div v-for="item in menuarray" class='d-flex'>
              <RadioButton v-model="consumeOrService" inputId="ingredient1" name="pizza" :value="item?.POType"
                @click="GetCode(item?.EntityId)" :disabled="codeStatus" />
              <label for="ingredient1" class="ms-2">{{
                item["SubMenuName"]
              }}</label>
            </div>

          </div> -->
          <b-row>
            <SupplierComponent v-model="SupformData" @update:modelValue="SupplierValue"
              :commonItemProps="commonItemProps" :disabled="SupplierDropDownDisable" @emitsupplierval="items = []"
              :IsSupEdit="IsSupEdit" :GrossAmount="POCalcDetails.TotalAmount" :MultiplePaymentList="MultiplePaymentList"
              @MultiplePayment="MultiplePayment" @deletedPayment="deletedPayment" @DeleteSupplier="DeleteSupplier" />

            <b-col lg="10" md="8" sm="12" cols="12">
              <div class="field mt-3">
                <Textarea v-model="requestForm.Remarks" :requiredIcon="false" placeholder=" " name="Remarks"
                  id="Remarks" :label="$t('item.Remarks')" :rules="{ required: false }" />
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="8" md="8" sm="12" cols="12">
              <b-row>
                <b-col>
                  <div class="field">
                    <Textarea name="Additional terms" :label="$t('PO.POCreation.additionalterms')"
                      :rules="{ required: false }" id="Additional terms" v-model="requestForm.AdditionalTerms" />
                  </div>
                </b-col>
                <b-col>
                  <div class="field">
                    <Textarea name="Reference" :label="$t('PO.POCreation.reference')" :rules="{ required: false }"
                      id="Reference" v-model="requestForm.Reference" />
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <p class="blue-txt" v-b-toggle.collapse-1>
                    {{ $t("PO.POCreation.addtransportcharges") }}
                  </p>
                  <b-collapse id="collapse-1">
                    <div class="field">
                      <TextField :required-icon="false" name="TransportCharges" id="TransportCharges" label=""
                        :rules="{ required: false, decimal: true }" v-model="requestForm.TransportCharges"
                        @keyup="TransportChargesOnChange" />
                    </div>
                  </b-collapse>
                </b-col>
                <b-col>
                  <p class="blue-txt" v-b-toggle.collapse-2>
                    {{ $t("PO.POCreation.addothercharges") }}
                  </p>
                  <b-collapse id="collapse-2">
                    <div class="field">
                      <TextField :required-icon="false" name="OtherCharges" id="OtherCharges" label=""
                        :rules="{ required: false, decimal: true }" v-model="requestForm.OtherCharges"
                        @keyup="OtherChargesOnChange" />
                    </div>
                  </b-collapse>
                </b-col>
                <b-col>
                  <p class="blue-txt" v-b-toggle.collapse-3>
                    {{ $t("PO.POCreation.FreightCharges") }}
                  </p>
                  <b-collapse id="collapse-3">
                    <div class="field">
                      <TextField :required-icon="false" name="FreightCharges" id="FreightCharges" label=""
                        :rules="{ required: false, decimal: true }" v-model="requestForm.Freightcharges"
                        @keyup="FreightChargesOnChange" />
                    </div>
                  </b-collapse>
                </b-col>
                <b-col>
                  <p class="blue-txt" v-b-toggle.collapse-4>
                    {{ $t("PO.POCreation.adddiscount") }}
                  </p>
                  <b-collapse id="collapse-4">
                    <div class="field">
                      <TextField :required-icon="false" name="Discount" id="Discount" label=""
                        :rules="{ required: false, decimal: true }" v-model="requestForm.DiscountAmount"
                        @keyup="DiscountAmountOnChange" />
                    </div>
                  </b-collapse>
                </b-col>
              </b-row>
            </b-col>
            <b-col lg="4" md="4" sm="12" cols="12">
              <b-row>
                <b-col>
                  <div class="d-flex align-items-center justify-content-between py-2">
                    <p>{{ $t("PO.POCreation.supplieraddress") }}</p>
                    <i class="pi pi-pencil" style="color: #3096ff" @click="EditSupplierAddress()"></i>
                  </div>
                  <div class="contentbg" v-if="!editsupplieraddress">
                    <p>{{ requestForm.SupplierAddress }}</p>
                  </div>
                  <div class="label-d-none field">
                    <Textarea v-model="requestForm.SupplierAddress" v-if="editsupplieraddress" name="supplierTextarea"
                      label="" :rules="{ required: false }" id="supplierTextarea" ref="supplierTextarea"
                      @blur="editsupplieraddress = false" />
                  </div>
                </b-col>
              </b-row>
              <b-row class="">
                <b-col>
                  <div class="d-flex align-items-center justify-content-between py-2">
                    <p>{{ $t("PO.POCreation.billingaddress") }}</p>
                    <i class="pi pi-pencil" style="color: #3096ff" @click="EdiBillAddress()"></i>
                  </div>
                  <div class="contentbg" v-if="!editbillingaddress">
                    <p>{{ requestForm.BillingAddress }}</p>
                  </div>
                  <div class="label-d-none field">
                    <Textarea v-model="requestForm.BillingAddress" v-if="editbillingaddress" name="billingTextarea"
                      label="" :rules="{ required: false }" id="billingTextarea" ref="billingTextarea"
                      @blur="editbillingaddress = false" />
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div class="d-flex align-items-center justify-content-between py-2">
                    <p>{{ $t("PO.POCreation.deliveryaddress") }}</p>
                    <i class="pi pi-pencil" style="color: #3096ff" @click="EditDeliveryAddress()"></i>
                  </div>
                  <div class="contentbg" v-if="!editdeliaddress">
                    <p>{{ requestForm.DeliveryAddress }}</p>
                  </div>
                  <div class="label-d-none field">
                    <Textarea v-model="requestForm.DeliveryAddress" v-if="editdeliaddress" name="deliveryTextarea"
                      label="" :rules="{ required: false }" id="deliveryTextarea" ref="deliveryTextarea"
                      @blur="editdeliaddress = false" />
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <div class="tab-view">
            <TabView class="tabview-custom" ref="tabview4" v-model:activeIndex="clases.ItemsReOrderTab">
              <TabPanel>
                <template #header>
                  <i class="pi pi-align-left pe-3"></i>
                  <span>Items</span>
                </template>
                <div>
                  <Item @additemclick="AddItems" :consumeOrService="consumeOrService" v-model:data-items="dataItems"
                    :show-fields="showFields" :addItemData="items" :commonItemProps="commonItemProps"
                    @calculation="TotalGrossCalc" :changeval="changeval" @ExcelData="ExcelDataImport"
                    @clearitem="clearItems" @ItemUpdated="ItemUpdated" />
                  <SkeletonTableLoader :columns="headers" :loading="loading" />
                  <!-- {{ ItemTable }} -->

                  <Tableview v-if="!loading" v-model:value="ItemTable" :paginator="true" class="p-datatable-gridlines"
                    :rows="10" dataKey="id" :rowHover="true" filterDisplay="menu" :loading="loading"
                    responsiveLayout="scroll" :columns="headers" :globalFilterFields="globalFilterFields"
                    :filters="filters" :seriaNlumber="true">
                    <template v-slot:Add>
                      <span>
                        <AddButton :btnname="$t('btn.plusaddnew')"></AddButton>
                      </span>
                    </template>

                    <template v-slot:StockInHand="{ data }">
                      {{
                        (data.StockInHand - (data.PickedQty + data.InTransist)).toFixed(2)
                      }}
                    </template>

                    <template v-slot:Brandmodelsize="{ data }">
                      <span>
                        <template v-if="data.BrandName">{{ data.BrandName }}</template>
                        <template v-if="data.BrandName && data.ModelNumberName">/</template>
                        <template v-if="data.ModelNumberName">{{ data.ModelNumberName }}</template>
                        <template v-if="(data.BrandName || data.ModelNumberName) && data.SizeName">/</template>
                        <template v-if="data.SizeName">{{ data.SizeName }}</template>
                      </span>
                    </template>
                    <template v-slot:action="{ data }">
                      <div class="d-flex align-items-center">
                        <EditIcon @click="IsItemEdit(data)" />
                        <DeleteIcon @click="ItemDeleteConfirm($event, data)" />
                        <Button @click="visible = true, getSupplierDetailsItemId(data)" icon="pi pi-info-circle"
                          class="p-button-rounded editicon p-button-text" />
                      </div>
                    </template>

                    <template v-slot:TempTaxSlot="{ data }">
                      <div class="label-d-none tablefield mb-0">
                        <Dropdown :options="TempTaxOption" v-model="data.PurchasePercentage" :disabled="false"
                          @change="TempTaxOnChange(data)" :show-clear="false" optionLabel="name" optionValue="value" />
                      </div>
                    </template>


                  </Tableview>

                </div>
              </TabPanel>
              <TabPanel>
                <template #header>
                  <i class="pi pi-shopping-bag pe-3"></i>
                  <span>Items below reorder level</span>
                </template>
                <p>
                  <AddItemsVue @AddSingleClick="AddSingleConfirmation('Single')" />
                  <ReorderETableview :rowHover="true" filterDisplay="menu" :loading="loading" responsiveLayout="scroll"
                    :columns="ReOrderheaders" :data="ReOrderData" @selection="ReOrderItemSelect"
                    :selection="selectedProduct" :selectionMode="true">

                    <template v-slot:Brandmodelsize="{ data }">
                      <p>
                        <template v-if="data.BrandName">{{ data.BrandName }}</template>
                        <template v-if="data.BrandName && data.ModelNumberName">/</template>
                        <template v-if="data.ModelNumberName">{{ data.ModelNumberName }}</template>
                        <template v-if="(data.BrandName || data.ModelNumberName) && data.SizeName">/</template>
                        <template v-if="data.SizeName">{{ data.SizeName }}</template>
                      </p>
                    </template>

                  </ReorderETableview>
                </p>
              </TabPanel>
            </TabView>
          </div>

          <b-row class="mt-1">
            <b-col lg="8" md="8">
            </b-col>
            <b-col lg="4" md="4">
              <b-row>
                <b-col class="ammount_footer">
                  <p class="light-txt">
                    Gross Amount
                  </p>
                  <p>
                    <span class="pe-1">&#8377</span>
                    {{ POCalcDetails.GrossAmount }}
                  </p>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="ammount_footer">
                  <p class="light-txt">
                    Discount Amount
                  </p>
                  <p>
                    <span class="pe-1">&#8377</span>
                    {{ POCalcDetails.DiscountAmount }}
                  </p>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="ammount_footer">
                  <p class="light-txt">
                    Tax Amount
                  </p>
                  <p>
                    <span class="pe-1">&#8377</span>
                    {{ POCalcDetails.TaxAmount }}
                  </p>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="ammount_footer">
                  <p class="light-txt">
                    SGST Amount
                  </p>
                  <p>
                    <span class="pe-1">&#8377</span>
                    {{ POCalcDetails.SGSTTaxAmount }}
                  </p>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="ammount_footer">
                  <p class="light-txt">
                    CGST Amount
                  </p>
                  <p>
                    <span class="pe-1">&#8377</span>
                    {{ POCalcDetails.CGSTTaxAmount }}
                  </p>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="ammount_footer">
                  <p class="light-txt">
                    IGST Amount
                  </p>
                  <p>
                    <span class="pe-1">&#8377</span>
                    {{ POCalcDetails.IGSTTaxAmount }}
                  </p>
                </b-col>
              </b-row>


              <b-row>
                <b-col class="ammount_footer">
                  <p class="light-txt">
                    Transport charges
                  </p>
                  <p>
                    <span class="pe-1">&#8377</span>
                    {{ POCalcDetails.Transportcharges }}
                  </p>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="ammount_footer">
                  <p class="light-txt">
                    Freight charges
                  </p>
                  <p>
                    <span class="pe-1">&#8377</span>
                    {{ POCalcDetails.Freightcharges }}
                  </p>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="ammount_footer">
                  <p class="light-txt">
                    Other charges
                  </p>
                  <p>
                    <span class="pe-1">&#8377</span>
                    {{ POCalcDetails.Othercharges }}
                  </p>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="d-flex align-items-center mt-5">
                  <p>
                    Grand Total
                  </p>
                </b-col>
              </b-row>

              <b-row>
                <b-col offset-lg="3" class="d-flex px-0">
                  <div class="totaldiv1">
                    <p class="component-heading">{{ POCalcDetails.ItemCount }}</p>

                    <p class="light-txt">Items Part of this PO</p>
                  </div>
                  <div class="totaldiv2">
                    <p class="component-heading"><span class="pe-1">&#8377</span>{{ POCalcDetails.TotalAmount }}</p>
                    <p class="light-txt mt-3">{{ $t('grn.value') }}</p>
                  </div>
                </b-col>
              </b-row>

            </b-col>
          </b-row>

        </div>
      </b-container>
    </b-form>
  </div>

  <Dialog :modal="true" v-model:visible="visible" :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '65vw' }" header="Item Info" @after-hide="visible = false">

    <Tableview :rowHover="true" filterDisplay="menu" :loading="loading" responsiveLayout="scroll"
      :columns="Iteminfoheaders" v-model:value="supplierDetailsList" :selectionMode="false">
      <template v-slot:Add>
        <span>
          <AddButton :btnname="$t('btn.plusaddnew')"></AddButton>
        </span>
      </template>
      <template v-slot:StockInHand="{ data }">
        {{
          (data.StockInHand - (data.PickedQty + data.InTransist)).toFixed(2)
        }}
      </template>
      <template v-slot:Brandmodelsize="{ data }">
        <span>
          <template v-if="data.BrandName != null && data.ModelNumberName != null && data.SizeName != null">{{
            data.BrandName + "/" + data.ModelNumberName + "/" + data.SizeName }}</template>
          <template v-else-if="data.BrandName != null && data.ModelNumberName != null">{{ data.BrandName
            + "/" + data.ModelNumberName }}</template>
          <template v-else-if="data.BrandName != null">{{ data.BrandName }}</template>
          <template v-else>{{ "-" }}</template>
        </span>
      </template>
    </Tableview>

  </Dialog>
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
  <AddItemConfirmation :Editmodel="AddItemmodel" @yes="CopyReorderData()" @no="AddItemmodel = false"
    :content="msgcontent" />
  <WarningMessage :visible="wariningPopup" :content="warningmsgcontent.warningcontent" @ok="ClosewariningPopup()" />
  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues"
    :PrintType="PrintType" />

  <Toast />
  <ConfirmPopup />

</template>
<script lang="ts">
import BackToMasters from "../../../../../components/FormComponents/BacktoMaster.vue";
import Headerlayout from "../../../../../components/Masters/HeaderLayout.vue";
import Badge from "primevue/badge";
import AddItemsVue from "../../../../../modules/Inventory/components/Transaction/AddItems.vue";
import { defineComponent, ref, computed, onMounted, Ref, watch } from "vue";
import Tableview from "../../../../../components/FormComponents/NormalTable.vue";
import ReorderETableview from "../../../../../components/FormComponents/EditableTable.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Item from "../../../../../modules/Inventory/components/Transaction/Item.vue";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import Bluebutton from "../../../../../components/GeneralButtons/SaveButton.vue";

import Footer from "../../../../../components/FormComponents/Footer.vue";
import cancel from "../../../../../components/GeneralButtons/CancelButtton.vue";
import TextField from "../../../../../components/FormComponents/TextInput.vue";
import CustomDropdown from "../../../../../components/FormComponents/Dropdown.vue";
import Datepicker from "../../../../../components/FormComponents/DatePicker.vue";
import SupplierComponent from "../../../../../modules/Inventory/components/Transaction/SupplierComponent.vue";
import commonService from "../../../../../modules/Inventory/Service/WithoutStockAffectService";
import common from "../../../../../modules/Inventory/Service/CommonService";
import { useForm } from "vee-validate";
import CreateSuccessully from "../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import EditConfirmation from "../../../../../components/FormComponents/EditConfirmation.vue";
import AlreadyExist from "../../../../../components/FormComponents/AlreadyExist.vue";
import AddItemConfirmation from "../../../../../components/FormComponents/AddItemsConfirmation.vue";
import WarningMessage from "../../../../../components/FormComponents/WarningMessage.vue";
import { value } from "dom7";
import MasterEmpty from "../../../../../components/Masters/MasterEmpty.vue";
import { useToast } from "primevue/usetoast";
import { useConfirm } from "primevue/useconfirm";

import moment from "moment";
import Textarea from "../../../../../components/FormComponents/TextArea.vue";
import CrystalReportPrintPopUp from "../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";
import StoreService from "../../../../../modules/Inventory/Service/StoreService";
import WithoutStockAffectService from "../../../../../modules/Inventory/Service/WithoutStockAffectService";

import axios from "axios";
import EntityOperations from "../../../../../modules/userManagement/Service/EntityOperations";
import { useI18n } from "vue-i18n";
import MastersService from "../../../../../modules/Inventory/Service/MastersService";
import SkeletonTableLoader from "../../../../../components/FormComponents/SkeletonTableLoader.vue";
import StoreDropDown from "../../../../../modules/Inventory/components/DropDown/StoreDropDown.vue";

import DataTableview from "../../../../../components/FormComponents/Table.vue";
import { setupHistoryManagement } from "../../../../../modules/Inventory/Service/HistoryManage";
import { globalCookiesConfig } from "vue3-cookies";
import StockWOFileUploadServices from "../../../../../modules/Inventory/Service/StockWOFileUploadService";
import POPaymentTermsDetailsServices from "../../../../../modules/Inventory/Service/POPaymentTermsDetails";
import { number } from "yup";
import { nextTick } from "vue";
import SkeletonForm from "../../../../../components/FormComponents/FormSkeletonLoader.vue"
export default defineComponent({
  components: {
    StoreDropDown,
    Textarea,
    AlreadyExist,
    CreateSuccessully,
    UpdatedSuccessfully,
    EditConfirmation,
    SupplierComponent,
    Badge,
    AddItemsVue,
    Item,
    Tableview,
    DataTableview,
    Footer,
    cancel,
    BackToMasters,
    Headerlayout,
    TextField,
    Datepicker,
    CustomDropdown,
    AddItemConfirmation,
    WarningMessage,
    MasterEmpty,
    CrystalReportPrintPopUp,
    Bluebutton,
    SkeletonTableLoader,
    ReorderETableview,
    SkeletonForm
  },
  props: {
    showone: {
      type: String,
      default: "",
    },
  },
  setup() {
    const { t } = useI18n();
    let session: any = localStorage.getItem("UsersData");

    let SessionRolesData: any = localStorage.getItem("RolesData");
    let rolesData;
    SessionRolesData = JSON.parse(SessionRolesData);
    if (SessionRolesData !== null) {
      rolesData = SessionRolesData
    }

    let DeptRoleMapId = SessionRolesData.DeptRoleMapId;
    const loadingforms = ref(false)

    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    const todayDate = ref(new Date());
    let currentDate = new Date().toISOString().slice(0, 10);

    const routers = useRouter();
    const router = useRoute();
    const toast = useToast();
    const confirm = useConfirm();

    const { handleSubmit, errors, resetForm, resetField } = useForm();

    const alreadyexistpop = ref(false);
    const successpop = ref(false);
    const updatepop = ref(false);
    const POid = router.query.StockTransId;
    const StockTransId = router.query.StockTransId ?? 0;
    let DStockTransId = 0;
    let OperationId = Number(router.query.OperationId) ?? 0;
    let Entitydata = ref();
    Entitydata.value = Number(router.query.EntityId) ?? 0;
    const ReOrderData: any = ref([]);
    const selectedProduct: any = ref([]);
    const AddItemmodel = ref(false);
    const wariningPopup = ref(false);
    const TodayDate = new Date();
    let SupplierDropDownDisable = ref(false);
    let List = ref([]);
    let consumeOrService = ref();
    let loading = ref(false);
    let SaveLoader = ref(false);
    let showitemfield = ref(false);
    const route = useRoute();
    let StoreDropdownDisable = ref(false);
    let changeval = ref(0);
    let billingaddress = ref("");
    let editbillingaddress = ref(false);
    let editsupplieraddress = ref(false);
    let editdeliaddress = ref(false);
    let editsuppaddress = ref(false);
    let SaveDraft = ref(0);
    let editSaveDraft = ref(1);
    let EditFlag = 0;
    let SaveFlag = ref(true);
    let id: any = 0;
    let IsFlag = Number(router.query.IsFlag) ?? 0;

    const newbillingaddress = ref("");
    let msgcontent = ref({ contentvalue: "" });
    let warningmsgcontent = ref({ warningcontent: "" });
    const confirmval = ref();
    let items: any = ref([]);
    let dupitems: any = ref([]);

    let fullPath = ref();
    let uploadedTableList: any = ref([])
    let DeletedFileUpload: any = []
    const StockWOFileUpload = ref([]);
    const PoPaymentTermsDetails: any = ref([]);
    let IsDraftFlag = Number(router.query.IsDraft);


    const ItemTable: any = ref([]);
    let ExcelResponse: any = ref([]);
    let menuarray: any = ref([]);
    const CrystalReportPopup = ref(false);
    const dataItems = ref({});
    const HiddenEditData = ref({});
    var arr: any = [];
    let POTypeEntityId: any = ref()
    let itemslist: any = ref([]);
    const IsSupEdit = ref(0);
    let StoreBranchMapId = Number(router.query.storebranchmapid) ?? 0;
    const StoreModel: any = ref()
    const visible: any = ref(false)
    let codeStatus = ref(false)

    let clases = ref({
      ItemsReOrderTab: 0,
      WithAndWithoutRateTab: 0,
    });

    const LoadPoDocNo = ref({
      Code: "",
    });

    const commonItemProps = ref({
      storeId: 0,
      type: 0,
      supplierId: 0,
      SupllierStateId: 0,
      itemType: 2,
      POFlag: 1,
      UnitRateZero: 1,
      POTypeEntityId: 0
    });

    const POCalcDetails: any = ref({
      GrossAmount: 0.00,
      TaxAmount: 0.00,
      SGSTTaxAmount: 0.00,
      CGSTTaxAmount: 0.00,
      IGSTTaxAmount: 0.00,
      Transportcharges: 0.00,
      Freightcharges: 0.00,
      Othercharges: 0.00,
      DiscountAmount: 0.00,
      ItemCount: 0,
      TotalAmount: 0.00
    })

    let StoreId = router.query.StoreId ?? 0;
    commonItemProps.value.storeId = Number(StoreId);

    const ParameterValues = ref({ Id: 0, BranchId: 0, HospitalId: 0 });
    const PrintType = ref({ Type: "S", FormId: 14, ModuleId: 3 });

    const StoreDropdown = ref({
      StoreOptions: [],
      StoreId: ref(),
      ToStoreBrMapId: ref(),
    });

    const Codes = ref({
      Label: "",
    });

    const CodesRef = ref({
      Label: "",
    });

    const DocNoObj = ref({
      Label1: "",
      Label2: "",
      Label2HideAndShow: true,
    });

    function ShowItems() {
      showitemfield.value = true;
    }
    const requestForm = ref({
      Id: 0,
      DocType: "",
      DocNo: "",
      RefId: 0,
      RefNo: "",
      SupplierId: 0,
      DocDate: ref(),
      FromStore: 0,
      ToStore: 0,
      HospitalId: 0,
      BranchId: 0,
      CreatedAt: currentDate,
      StoreId: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      CreatedBy: 0,
      EntityId: 0,
      EntityOperationId: 0,
      DeptRoleId: 0,
      IsServiceLevel: consumeOrService,
      DeliveryAddress: "",
      BillingAddress: "",
      SupplierAddress: "",
      AdditionalTerms: "",
      Reference: "",

      Remarks: "",
      Freightcharges: "0.00",

      TaxAmount: 0.00,
      SGSTTaxAmount: 0.00,
      CGSTTaxAmount: 0.00,
      IGSTTaxAmount: 0.00,
      TransportCharges: "0.00",
      OtherCharges: "0.00",
      DiscountAmount: "0.00",
      Amount: 0.00,
      StoreBrMapId: 0,
      FromStoreBrMapId: 0,
      ToStoreBrMapId: 0,
      FromStoreBranchId: 0,
      ToStoreBranchId: 0,
      IsDraft: 0,
      StockWODetailList: []
    });

    const SupformData = ref({
      SupplierId: ref(),
      SupplierName: "",
      PaymentTermsId: ref(),
      DeliveryTermsId: ref(),
      AdditionalTerms: "",
      Reference: "",
      BillingAddress: "",
      Email: "",
      PaymentTermsName: "",
      DeliveryTermsName: "",
      SupllierCountryId: 0,
      SupllierStateId: 0,
      SupllierCityId: 0,
      WarrantyTermsId: ref(),
      WarrantyTermsName: "",
    });

    let showFields = {
      Name: {
        show: true,
        require: true,
      },
      Batch: {
        show: false,
        require: false,
      },
      PackSize: {
        show: true,
        require: true,
      },
      UnitRate: {
        show: true,
        require: true,
      },
      Qty: {
        show: true,
        require: true,
      },
      MRP: {
        show: false,
        require: false,
      },
      Discount: {
        show: true,
        require: false,
      },
      AvailQty: {
        show: false,
        require: false,
      },
      IssuedQty: {
        show: false,
        require: false,
      },
      RequestedQty: {
        show: false,
        require: false,
      },
      Brand: {
        show: true,
        require: false,
      },
      ModelNumber: {
        show: true,
        require: false,
      },
      Size: {
        show: true,
        require: false,
      },
      UOM: {
        show: true,
        require: true,
      },
      ExcelImport: {
        show: false,
      },
    };

    const ReOrderheaders = [
      {
        header: t('storetabdetails.pocreationtable.Category'),
        field: "ItemCategory1",
        class: "smallwidth coumnfreezeleft1",
      },
      {
        header: t('storetabdetails.pocreationtable.Code'),
        field: "ItemProductId",
        class: "smallwidth coumnfreezeleft2",
      },
      {
        header: t('storetabdetails.pocreationtable.Name'),
        field: "Itemname1",

        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth coumnfreezeleft3",
      },
      {
        header: t('storetabdetails.pocreationtable.Brand/Model/Size'),
        field: "",
        slot: "Brandmodelsize",
        fieldDisplay: "false",
      },
      {
        header: t('storetabdetails.pocreationtable.LPOSupplier'),
        field: "LPOSupplierName",
        bodyclass: "text_overflow2",

        class: "smallwidth",
      },
      {
        header: t('storetabdetails.pocreationtable.LPODate'),
        field: "LPODate",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t('storetabdetails.pocreationtable.UOM'),
        field: "PurchaseUnitName",
        class: "smallwidth",
      },

      {
        header: t('storetabdetails.pocreationtable.AvlQty'),
        slot: 'StockInHand',
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t('storetabdetails.pocreationtable.PickedQty'),
        field: "PickedQty",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.pocreationtable.InTransist'),
        field: "InTransist",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.pocreationtable.Min'),
        field: "MinReOrderLevel",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t('storetabdetails.pocreationtable.Max'),
        field: "MaxReOrderLevel",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t('storetabdetails.pocreationtable.Consumption'),
        field: "Consumption",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t('storetabdetails.pocreationtable.Reorder'),
        field: "ReOrderLevel",
        bodyclass: "right_td",

        class: "smallwidth",
      },
    ];
    //ReOrder Level Table
    const Iteminfoheaders = [
      {
        header: t('storetabdetails.pocreationtable.SupplierName'),
        field: "POSupplierName",
        class: "smallwidth",
      },
      {
        header: "Branch",
        field: "BranchName",
        class: "smallwidth",
      },
      {
        header: t('storetabdetails.pocreationtable.Store'),
        field: "StoreName",
        class: "smallwidth",
      },
      {
        header: "Brand/model/size",
        field: "",
        slot: "Brandmodelsize",
        fieldDisplay: "false",
      },
      {
        header: t('storetabdetails.pocreationtable.Qty'),
        field: "POQty",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t('storetabdetails.pocreationtable.UnitRate'),
        field: "UnitRate",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t('storetabdetails.pocreationtable.Rate'),
        field: "Rate",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: "Avl Qty",
        slot: 'StockInHand',
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t('storetabdetails.pocreationtable.PickedQty'),
        field: "PickedQty",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.pocreationtable.InTransist'),
        field: "InTransist",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: "ReorderLevel",
        field: "ReOrderLevel",
        bodyclass: "right_td",
        class: "smallwidth",
      },
    ];

    const headers = [

      {
        header: t('storetabdetails.pocreationtable.Category'),
        field: "ItemCategory1",
        class: "smallwidth coumnfreezeleft1"
      },
      {
        header: t('storetabdetails.pocreationtable.Code'),
        field: "ItemProductId",
        class: "smallwidth coumnfreezeleft2"
      },
      {
        header: t('storetabdetails.pocreationtable.Name'),
        field: "Itemname1",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth coumnfreezeleft3",
      },
      {
        header: t('storetabdetails.pocreationtable.Brand/Model/Size'),
        field: "",
        slot: "Brandmodelsize",
        fieldDisplay: "false",
      },
      {
        header: t('storetabdetails.pocreationtable.UOM'),
        field: "UOMName",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t('storetabdetails.pocreationtable.AvlQty'),
        slot: 'StockInHand',
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t('storetabdetails.pocreationtable.PickedQty'),
        field: "PickedQty",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.pocreationtable.InTransist'),
        field: "InTransist",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.pocreationtable.UnitRate'),
        field: "UnitRate",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.pocreationtable.Qty'),
        field: "ItemQuantity",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.pocreationtable.Rate'),
        field: "Rate",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.grncreationtable.Discount%'),
        field: "Discount",
        bodyclass: "right_td",
        class: "smallwidth"

      },
      {
        header: t('storetabdetails.grncreationtable.Discount'),
        field: "DiscountAmount",
        bodyclass: "right_td",
        class: "smallwidth"

      },
      // commented for temp tax changes 
      // {
      //   header: t('storetabdetails.pocreationtable.Tax%'),
      //   field: "PurchasePercentage",
      //   bodyclass: "right_td",
      //   class: "smallwidth"
      // },
      {
        header: t('storetabdetails.pocreationtable.Tax%'),
        field: "PurchasePercentage",
        bodyclass: "right_td",
        class: "smallwidth",
        slot: "TempTaxSlot",
        fieldDisplay: "false",
      },
      {
        header: t('storetabdetails.pocreationtable.Tax'),
        field: "Purchasetaxamount",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.pocreationtable.SGST%'),
        field: "SGSTTax",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.pocreationtable.SGST'),
        field: "SGSTTaxAmount",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.pocreationtable.CGST%'),
        field: "CGSTTax",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.pocreationtable.CGST'),
        field: "CGSTTaxAmount",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.pocreationtable.IGST%'),
        field: "IGSTTax",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.pocreationtable.IGST'),
        field: "IGSTTaxAmount",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.pocreationtable.Total'),
        field: "Totalvalue",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.pocreationtable.Description'),
        field: "Description",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "last-column-position",
        fieldDisplay: "false",
      },
    ];

    const paramValue = computed(() => {
      return route.query.param as string;
    });
    const globalFilterFields = ref(headers.map((col) => col.field));
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Name: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      CreatedAt: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },
      Code: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      length: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
    };

    onMounted(() => {
      debugger;
      ReadyFunction();
    });

    async function ReadyFunction() {
      loadingforms.value = true;
      debugger;
      requestForm.value.DocDate = TodayDate;
      await LoadMenus();
      await GetStoresByUserId();
      if (StockTransId != "0" && route.query.param == "PO") {
        DocNoObj.value.Label1 = t("PO.POCreation.pono");
        DocNoObj.value.Label2 = t("PO.POCreation.refcode");
        StoreDropdownDisable.value = false;
        await IsEdit();
      } else if (StockTransId != "0" && route.query.param == "POAmendment") {
        DocNoObj.value.Label1 = t("PO.POCreation.poammendmentcode");
        DocNoObj.value.Label2 = t("PO.POCreation.pocode");
        StoreDropdownDisable.value = false;
        await GetCode(3039);
        await IsEdit();
      } else {
        DocNoObj.value.Label1 = t("PO.POCreation.pono");
        DocNoObj.value.Label2 = "";
        DocNoObj.value.Label2HideAndShow = false;
      }
      await LoadReOrderLevel();
      loadingforms.value = false;
    }

    function SelectStore(value) {
      debugger

      if (value) {
        requestForm.value.ToStore = value.Id
        requestForm.value.ToStoreBrMapId = value.StoreBranchMapId
        requestForm.value.ToStoreBranchId = value.BranchId
        StoreDropdown.value.ToStoreBrMapId = value
      }
    }

    function IsItemEdit(data) {
      debugger;
      dataItems.value = {};
      dataItems.value = data;
      dataItems.value["IsEdit"] = 1;
      EditFlag = 1;
      HiddenEditData.value = data;
    }

    // async function LoadMenus() {
    //   debugger;
    //   let response = await MastersService.GetMenus(
    //     7,
    //     rolesData.RoleId,
    //     usersData.OrganizationId
    //   );

    //   console.log("MenuListStoreTabDetails", response["result"]);
    //   menuarray.value = response["result"].map((x) => {
    //     if (x.EntityId == 3077) {
    //       x.POType = 0
    //     }
    //     else if (x.EntityId == 3078) {
    //       x.POType = 1
    //     }
    //     else if (x.EntityId == 3079) {
    //       x.POType = 3
    //     }
    //     else if (x.EntityId == 3129) {
    //       x.POType = 4
    //     }
    //     else if (x.EntityId == 3131) {
    //       x.POType = 5
    //     }
    //     else if (x.EntityId == 3149) {
    //       x.POType = 6
    //     }
    //     else if (x.EntityId == 3150) {
    //       x.POType = 7
    //     }
    //     return x;
    //   });
    // }

    async function LoadMenus() {
      debugger;
      console.time("API Call");
      let response = await MastersService.GetMenus(7, rolesData.RoleId, usersData.OrganizationId);
      console.timeEnd("API Call");

      console.time("Mapping Data");

      const POTypeMap = {
        3077: 0,
        3078: 1,
        3079: 3,
        3129: 4,
        3131: 5,
        3149: 6,
        3150: 7
      };

      let updatedArray: any = [];
      response["result"].forEach((x) => {
        updatedArray.push({ ...x, POType: POTypeMap[x.EntityId] ?? x.POType });
      });

      menuarray.value = updatedArray;

      console.timeEnd("Mapping Data");
    }

    const ItemDeleteConfirm = (event, data) => {
      confirm.require({
        target: event.currentTarget,
        message: 'Do you want to delete this record?',
        icon: 'pi pi-info-circle',
        rejectClass: 'p-button-secondary p-button-outlined p-button-sm',
        acceptClass: 'p-button-danger p-button-sm',
        rejectLabel: 'Cancel',
        acceptLabel: 'Delete',
        accept: () => {
          IsItemDelete(data)
        },
        reject: () => {
          toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
        }
      });
    };

    async function IsItemDelete(data) {
      debugger;
      let msg = null;
      if (ItemTable.value.length > 1) {
        let param = router.query.param;

        if (param == "PO") {
          if (data["StockDetailsId"] && data["StockDetailsId"] != 0) {
            let result = await commonService.deleteStockWoDetails(
              data.StockDetailsId
            );
            msg = result["ErrorInfo"].ErrorCode;
          }
        }

        if (msg == null) {
          ItemTable.value = ItemTable.value.filter(
            (item) =>
              item["StockDetailsId"] !== data.StockDetailsId
          );

          items.value = ItemTable.value.filter(
            (item) =>
              item["StockDetailsId"] !== data.StockDetailsId
          );

          toast.add({ severity: 'info', summary: 'Confirmed', detail: 'Record deleted', life: 3000 });
          return;
        }
        else {
          toast.add({ severity: 'error', summary: 'Error', detail: msg, life: 3000 });
          return;
        }
      }
      else {
        toast.add({
          severity: "info",
          summary: "Cannot Delete Last Item",
          detail: "You cannot delete the last remaining item.",
          life: 3000,
        });
        return;
      }
    }

    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      setupHistoryManagement(routers, 2);
    }

    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
    }

    //Get Code
    async function GetCode(EntityId) {
      debugger;
      let data = {
        EntityId: EntityId,
        HospitalId: HospitalId,
        BranchId: router.query.BranchId ?? 0,
        StoreId: router.query.StoreId ?? 0
      };

      let result: any = await common.getCodeTemplate(data);

      requestForm.value.DocNo = result;
      POTypeEntityId.value = EntityId
      commonItemProps.value.POTypeEntityId = EntityId
      if (EntityId == 3077) {
        OperationId = 3077001
      }
      if (EntityId == 3078) {
        OperationId = 3078001
      }
      if (EntityId == 3079) {
        OperationId = 3079001
      }
      if (EntityId == 3129) {
        OperationId = 3129001
      }
      if (EntityId == 3131) {
        OperationId = 3131001
      }
      if (EntityId == 3149) {
        OperationId = 3149001
      }
      if (EntityId == 3150) {
        OperationId = 3150001
      }

    }


    //Edit Function
    const IsEdit = async () => {
      try {
        debugger;
        loading.value = true;
        const response = await commonService.GetByStockWOTransId(StockTransId);
        let data = response["result"];
        commonItemProps.value.POTypeEntityId = response["result"][0].EntityId;

        IsSupEdit.value = 1;
        Object.keys(requestForm.value).forEach((key) => {
          if (StockTransId != "0" && route.query.param == "PO") {
            if (
              key == "RefNo" &&
              (data[0][key] == "" || data[0][key] == null)
            ) {
              DocNoObj.value.Label2HideAndShow = false;
            }
            if (data[0][key]) requestForm.value[key] = data[0][key];
          } else if (
            StockTransId != "0" &&
            route.query.param == "POAmendment"
          ) {
            if (key == "DocNo") {
              requestForm.value.RefNo = data[0][key];
            } else {
              if (key != "RefNo") {
                if (data[0][key]) requestForm.value[key] = data[0][key];
              }
            }
          }
        });
        requestForm.value.DocDate = moment(data[0].DocDate).format('DD-MM-YYYY');
        Object.keys(SupformData.value).forEach((key) => {
          if (key != "DeliveryTermsId" && key != "PaymentTermsId" && key != "WarrantyTermsId") {
            if (data[0][key]) SupformData.value[key] = data[0][key];
          }
        });
        SupformData.value.SupplierId = data[0]["SupplierId"];
        SupplierDropDownDisable.value = true;
        Object.keys(calcValues.value).forEach((key) => {
          if (data[0][key]) calcValues.value[key] = data[0][key];
        });
        requestForm.value.SupplierAddress = data[0].SupplierAddress;
        id = router.query.StockTransId ?? 0;
        editSaveDraft.value = data[0].IsDraft;
        await LoadMenus()
        consumeOrService.value = response["result"][0].IsServiceLevel;
        codeStatus.value = true
        StoreDropdown.value.StoreId = response["result"][0].ToStore;
        StoreDropdown.value.ToStoreBrMapId = response["result"][0].ToStoreBrMapId;
        requestForm.value.ToStore = response["result"][0].ToStore;
        requestForm.value.ToStoreBrMapId = response["result"][0].ToStoreBrMapId;
        requestForm.value.FromStoreBranchId = response["result"][0].FromStoreBranchId;
        requestForm.value.ToStoreBranchId = response["result"][0].ToStoreBranchId;
        requestForm.value.StoreBrMapId = response["result"][0].StoreBrMapId;
        requestForm.value.FromStoreBrMapId = response["result"][0].FromStoreBrMapId;
        POTypeEntityId.value = response["result"][0].EntityId;
        const FileUploadresult = await StockWOFileUploadServices.getStockWOFileById(
          StockTransId
        );
        if (FileUploadresult['result'].length > 0) {
          for (let i = 0; i < FileUploadresult['result'].length; i++) {
            let Fileobj = {};
            (Fileobj["url"] = FileUploadresult['result'][i].FileName.split('/FileUpload/')[1]),
              (Fileobj["fileName"] = FileUploadresult['result'][i].FileName.split('/').pop()),
              (Fileobj["fileType"] = Fileobj["url"].split('/')[0]),
              (Fileobj["fullPath"] = FileUploadresult['result'][i].FileName),
              (Fileobj["Id"] = FileUploadresult['result'][i].Id),
              uploadedTableList.value.push(Fileobj)
          }
        }
        await TransportChargesOnChange();
        await OtherChargesOnChange();
        await FreightChargesOnChange();
        ItemTable.value = data
          .map((item) => {
            item.UnitRate = Number(item.UnitRate).toFixed(2);
            item.Rate = Number(item.Rate).toFixed(2);
            item.Discount = Number(item.ItemDiscount).toFixed(2);
            item.DiscountAmount = Number(item.ItemDiscountAmount).toFixed(2);
            item.Purchasetaxamount = Number(item.Purchasetaxamount).toFixed(2);
            item.SGSTTaxAmount = Number(item.SGSTTaxAmount).toFixed(2);
            item.CGSTTaxAmount = Number(item.CGSTTaxAmount).toFixed(2);
            item.IGSTTaxAmount = Number(item.IGSTTaxAmount).toFixed(2);
            item.Totalvalue = Number(item.Amount).toFixed(2);
            return item
          });
        items.value = ItemTable.value;
        loading.value = false
        setTimeout(() => {
          changeval.value = 2;
        }, 1000);
        console.log(requestForm.value);
      } catch (error) {
        alert(error);
      }
    };

    function TotalGrossCalc(value1) {
      debugger;
      calcValues.value.grossamount = value1.grossamount;
    }

    const goToFirstPage = () => {
      setupHistoryManagement(routers, 5);
    };
    const IsSubmitDraft = handleSubmit(async (values) => {
      debugger;
      let response: any;
      let message = "";
      var FileUploadArray: any = [];
      debugger;
      if (ItemTable.value.length > 0) {
        requestForm.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        requestForm.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        requestForm.value.IsDraft = 1;
        requestForm.value.BranchId = Number(router.query.BranchId) ?? 0;
        requestForm.value.HospitalId = HospitalId;
        requestForm.value.ModifiedBy = UserId;
        requestForm.value.CreatedBy = UserId;
        requestForm.value.DocDate = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");

        requestForm.value.EntityId = POTypeEntityId.value;
        // requestForm.value.EntityOperationId =
        //   editSaveDraft.value == 1 ? 599 : OperationId;

        if (POTypeEntityId.value == 3077) {
          requestForm.value.EntityOperationId = 3077001
        }
        if (POTypeEntityId.value == 3078) {
          requestForm.value.EntityOperationId = 3078001
        }
        if (POTypeEntityId.value == 3079) {
          requestForm.value.EntityOperationId = 3079001
        }
        if (POTypeEntityId.value == 3129) {
          requestForm.value.EntityOperationId = 3129001
        }
        if (POTypeEntityId.value == 3149) {
          requestForm.value.EntityOperationId = 3149001
        }
        if (POTypeEntityId.value == 3150) {
          requestForm.value.EntityOperationId = 3150001
        }
        requestForm.value.DeptRoleId = rolesData.DeptRoleMapId;

        // requestForm.value.IsDraft = SaveDraft.value;
        SupformData.value.BillingAddress = requestForm.value.BillingAddress;
        SupformData.value.AdditionalTerms = requestForm.value.AdditionalTerms;
        SupformData.value.Reference = requestForm.value.Reference;
        SupformData.value.SupplierId = !SupformData.value.SupplierId
          ? 0
          : SupformData.value.SupplierId;

        SupformData.value.PaymentTermsId = !SupformData.value.PaymentTermsId
          ? 0
          : SupformData.value.PaymentTermsId;

        SupformData.value.DeliveryTermsId = !SupformData.value.DeliveryTermsId
          ? 0
          : SupformData.value.DeliveryTermsId;

        SupformData.value.WarrantyTermsId = !SupformData.value.WarrantyTermsId
          ? 0
          : SupformData.value.WarrantyTermsId;

        requestForm.value.Id = Number(StockTransId) == 0 ? requestForm.value.Id : Number(StockTransId)

        await pocalculation()

        requestForm.value.TaxAmount = POCalcDetails.value.TaxAmount
        requestForm.value.SGSTTaxAmount = POCalcDetails.value.SGSTTaxAmount
        requestForm.value.CGSTTaxAmount = POCalcDetails.value.CGSTTaxAmount
        requestForm.value.IGSTTaxAmount = POCalcDetails.value.IGSTTaxAmount
        requestForm.value.Amount = POCalcDetails.value.TotalAmount

        requestForm.value.StoreId = Number(StoreId);
        requestForm.value.FromStore = Number(StoreId);
        requestForm.value.StoreBrMapId = Number(StoreBranchMapId);
        requestForm.value.FromStoreBranchId = Number(router.query.BranchId) ?? 0;
        requestForm.value.FromStoreBrMapId = Number(StoreBranchMapId);

        const form = Object.assign(requestForm.value, SupformData.value);

        let param = router.query.param;
        if (param == "PO") {
          requestForm.value.DocType = "4";
        } else if (param == "POAmendment") {
          requestForm.value.DocType = "6";
        }

        if (param == "PO") {
          if (id != "0") {
            id =
              id != "0"
                ? Number(id)
                : Number(id);
          }
          else {
            requestForm.value.Id = 0;
          }
        } else {
          requestForm.value.RefId = Number(POid);

          if (id != "0" && IsFlag == 1) {
            requestForm.value.Id = 0;
          }
          else {
            id = id;
          }
        }

        let StockDetailsId;
        debugger;
        for (let i = 0; i < dupitems.value.length; i++) {
          let obj = {};

          if (
            (param == "PO" && StockTransId == 0 && DStockTransId == 0) ||
            (param == "POAmendment" && StockTransId != 0)
          ) {
            if (param == "POAmendment" && editSaveDraft.value == 1) {
              StockDetailsId = dupitems.value[i]["StockDetailsId"];
            }
            if (param == "PO" && editSaveDraft.value == 1) {
              StockDetailsId = dupitems.value[i]["StockDetailsId"];
            }
            else {
              StockDetailsId = 0;
            }
          } else if (
            param == "PO" &&
            (StockTransId != 0 || DStockTransId != 0)
          ) {
            StockDetailsId = dupitems.value[i]["StockDetailsId"];
          }

          (obj["Id"] = StockDetailsId),
            (obj["ItemId"] = dupitems.value[i]["ItemId"]),
            (obj["Qty"] = dupitems.value[i]["ItemQuantity"]),
            (obj["RefId"] = id),
            (obj["PackSizeId"] = dupitems.value[i]["PackSizeId"]),
            (obj["HSNId"] = dupitems.value[i]["HSNId"]),
            (obj["UOM"] = dupitems.value[i]["UOM"]),

            (obj["DiscountPer"] = dupitems.value[i]["Discount"]),
            (obj["DiscountAmount"] = dupitems.value[i]["DiscountAmount"]),

            (obj["PurchaseTax"] = dupitems.value[i]["PurchasePercentage"]),
            (obj["PurchaseTaxAmount"] = dupitems.value[i]["Purchasetaxamount"]),

            (obj["SGSTTax"] = dupitems.value[i]["SGSTTax"]),
            (obj["SGSTTaxAmount"] = dupitems.value[i]["SGSTTaxAmount"]),
            (obj["CGSTTax"] = dupitems.value[i]["CGSTTax"]),
            (obj["CGSTTaxAmount"] = dupitems.value[i]["CGSTTaxAmount"]),
            (obj["IGSTTax"] = dupitems.value[i]["IGSTTax"]),
            (obj["IGSTTaxAmount"] = dupitems.value[i]["IGSTTaxAmount"]),

            (obj["Amount"] = dupitems.value[i]["Totalvalue"]),
            (obj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
            (obj["ModifiedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),

            (obj["CreatedBy"] = UserId),
            (obj["ModifiedBy"] = UserId),
            (obj["Rate"] = dupitems.value[i]["Rate"]),
            (obj["UnitRate"] = dupitems.value[i]["UnitRate"]),
            (obj["Description"] = dupitems.value[i]["Description"]),
            (obj["Brand"] =
              dupitems.value[i]["Brand"] == null ? 0 : dupitems.value[i]["Brand"]),
            (obj["ModelNumber"] =
              dupitems.value[i]["ModelNumber"] == null
                ? 0
                : dupitems.value[i]["ModelNumber"]),
            (obj["Size"] =
              dupitems.value[i]["Size"] == null ? 0 : dupitems.value[i]["Size"]);

          arr[i] = obj;
        }

        requestForm.value.StockWODetailList = arr

        let result = await commonService.createStockWODraft(requestForm.value);
        id = result["result"][0].Id
        requestForm.value.Id = id
        // Since we're editing a single item and we know which item was edited
        const ResultList = result["result"][0];

        // If we have the edited item data and the result contains StockWODetailList
        if (ResultList && ResultList.StockWODetailList && ResultList.StockWODetailList.length > 0) {
          // Make sure dupitems has at least one item
          if (dupitems.value && dupitems.value.length > 0) {
            // Find the item with IsEdit flag set to 1 - this is the item that was just edited
            const editedItemIndex = items.value.findIndex(item => item.IsEdit === 1);

            // If the item is found, update its ID with the new ID from the result
            if (editedItemIndex !== -1) {
              items.value[editedItemIndex].Id = ResultList.StockWODetailList[0]['Id'];
              items.value[editedItemIndex].StockDetailsId = ResultList.StockWODetailList[0]['Id'];
              console.log("Updated item ID for edited item:", items.value[editedItemIndex].Id);

              // Reset the IsEdit flag after updating to prevent future confusion
              items.value[editedItemIndex].IsEdit = 0;
            } else {
              // Fallback to the previous method if no item has IsEdit=1
              const fallbackIndex = items.value.findIndex(item =>
                item.ItemId === dupitems.value[0].ItemId &&
                item.Brand === dupitems.value[0].Brand &&
                item.ModelNumber === dupitems.value[0].ModelNumber &&
                item.Size === dupitems.value[0].Size
              );

              if (fallbackIndex !== -1) {
                items.value[fallbackIndex].Id = ResultList.StockWODetailList[0]['Id'];
                items.value[fallbackIndex].StockDetailsId = ResultList.StockWODetailList[0]['Id'];
                console.log("Updated item ID using fallback method:", items.value[fallbackIndex].Id);
              }
            }
          } else {
            console.log("No items in dupitems.value or EditFlag is not 1");
          }
        } else {
          console.log("No StockWODetailList in result");
        }
        PoPaymentTermsDetails.value = []
        if (MultiplePaymentList.value.length != 0) {
          for (let i = 0; i < MultiplePaymentList.value.length; i++) {
            let PaymentTermsobj = {};
            if (MultiplePaymentList.value[i].PayTermsId != 0) {
              (PaymentTermsobj["Id"] = MultiplePaymentList.value[i].Id),
                (PaymentTermsobj["POId"] = requestForm.value.Id),
                (PaymentTermsobj["PayTermsId"] = MultiplePaymentList.value[i].PayTermsId),
                (PaymentTermsobj["Description"] = MultiplePaymentList.value[i].Description),
                (PaymentTermsobj["Percentage"] = Number(MultiplePaymentList.value[i].Percentage)),
                (PaymentTermsobj["Amount"] = Number(MultiplePaymentList.value[i].Amount)),
                (PaymentTermsobj["Days"] = Number(MultiplePaymentList.value[i].NoOfDays)),
                (PaymentTermsobj["Status"] = 0),
                (PaymentTermsobj["Storeid"] = Number(StoreId)),
                (PaymentTermsobj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
                (PaymentTermsobj["CreatedBy"] = UserId),
                (PaymentTermsobj["ModifiedBy"] = UserId),
                (PaymentTermsobj["ModifiedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
                (PaymentTermsobj["IsApproved"] = 0),
                (PaymentTermsobj["HospitalId"] = HospitalId),
                (PaymentTermsobj["BranchId"] = Number(router.query.BranchId) ?? 0),
                (PaymentTermsobj["PaymentTermsDesc"] = ''),
                (PaymentTermsobj["FileUpload"] = ''),
                (PaymentTermsobj["Initiate"] = false)
              PoPaymentTermsDetails.value.push(PaymentTermsobj)
            }

          }
          let PoPaymentTermsDetailsResult = await POPaymentTermsDetailsServices.insert(PoPaymentTermsDetails.value);
          debugger
          for (let i = 0; i < MultiplePaymentList.value.length; i++) {
            const ResultList = PoPaymentTermsDetailsResult["result"][i]
            MultiplePaymentList.value[i]['Id'] = ResultList['Id']
          }
        }
        if (uploadedTableList.value.length != 0) {
          for (let i = 0; i < uploadedTableList.value.length; i++) {
            let Fileobj = {};
            (Fileobj["Id"] = uploadedTableList.value[i].Id),
              (Fileobj["DocType"] = requestForm.value.DocType),
              (Fileobj["RefId"] = requestForm.value.Id),
              (Fileobj["FileName"] = uploadedTableList.value[i].fileName),
              (Fileobj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (Fileobj["CreatedBy"] = UserId),
              (Fileobj["ModifiedBy"] = 0),
              (Fileobj["EntityId"] = Number(Entitydata.value)),
              (Fileobj["IsApproved"] = 0),
              FileUploadArray.push(Fileobj)
          }
          StockWOFileUpload.value = FileUploadArray
          let FileUploadResult = await StockWOFileUploadServices.insertStockWOFile(StockWOFileUpload.value);
          debugger
          for (let i = 0; i < uploadedTableList.value.length; i++) {
            uploadedTableList.value[i].Id = FileUploadResult["result"][i]['Id'];
          }
        }
        loading.value = false
      } else {
        toast.add({
          severity: "warn",
          summary: "Item Required",
          detail: "Please add an item before proceeding.",
          life: 3000,
        });
      }
    })

    const AddItems = async (value) => {
      debugger;
      console.log(value);
      dupitems.value = []
      ItemTable.value = value;
      const lastIndex = Number(ItemTable.value.length - 1);
      dupitems.value.push(ItemTable.value[lastIndex])
      if (StockTransId != "0" && requestForm.value.IsDraft == 0) {
      }
      else {
        if (router.query.param != "POAmendment") {
          await IsSubmitDraft();
        }
      }
    };

    function debounce<T extends (...args: any[]) => void>(func: T, wait: number) {
      let timeout: ReturnType<typeof setTimeout>;

      return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
      };
    }

    const debouncedPocalculation = debounce(pocalculation, 300);

    watch(items, (newItems, oldItems) => {
      debugger;
      if (ItemTable.value.length > 0) {
        debouncedPocalculation();
      }
    }, { deep: true });


    async function pocalculation() {
      debugger;
      await POCalcDetailsClear();
      for (let i = 0; i < ItemTable.value.length; i++) {
        calcValues.value.grossamount += parseFloat(ItemTable.value[i]["Rate"]);
        POCalcDetails.value.GrossAmount += parseFloat(ItemTable.value[i]["Rate"]);
        POCalcDetails.value.DiscountAmount += parseFloat(ItemTable.value[i]["DiscountAmount"]);
        POCalcDetails.value.TaxAmount += parseFloat(ItemTable.value[i]["Purchasetaxamount"]);
        POCalcDetails.value.SGSTTaxAmount += parseFloat(ItemTable.value[i]["SGSTTaxAmount"]);
        POCalcDetails.value.CGSTTaxAmount += parseFloat(ItemTable.value[i]["CGSTTaxAmount"]);
        POCalcDetails.value.IGSTTaxAmount += parseFloat(ItemTable.value[i]["IGSTTaxAmount"]);
      }
      POCalcDetails.value.GrossAmount = Number(POCalcDetails.value.GrossAmount).toFixed(2);
      POCalcDetails.value.DiscountAmount = Number(Number(requestForm.value.DiscountAmount) + Number(POCalcDetails.value.DiscountAmount)).toFixed(2);
      POCalcDetails.value.TaxAmount = Number(POCalcDetails.value.TaxAmount).toFixed(2);
      POCalcDetails.value.SGSTTaxAmount = Number(POCalcDetails.value.SGSTTaxAmount).toFixed(2);
      POCalcDetails.value.CGSTTaxAmount = Number(POCalcDetails.value.CGSTTaxAmount).toFixed(2);
      POCalcDetails.value.IGSTTaxAmount = Number(POCalcDetails.value.IGSTTaxAmount).toFixed(2);
      poSubcalculation()
    };

    const poSubcalculation = () => {
      debugger;
      if (ItemTable.value.length > 0) {
        POCalcDetails.value.ItemCount = ItemTable.value.length;
      }
      POCalcDetails.value.TotalAmount = ((Number(POCalcDetails.value.GrossAmount) - Number(POCalcDetails.value.DiscountAmount)) + (Number(POCalcDetails.value.TaxAmount) + Number(POCalcDetails.value.Transportcharges) + Number(POCalcDetails.value.Freightcharges) + Number(POCalcDetails.value.Othercharges))).toFixed(2)
    }

    function POCalcDetailsClear() {
      debugger;
      POCalcDetails.value.GrossAmount = 0.00;
      POCalcDetails.value.DiscountAmount = 0.00;
      POCalcDetails.value.TaxAmount = 0.00;
      POCalcDetails.value.SGSTTaxAmount = 0.00;
      POCalcDetails.value.CGSTTaxAmount = 0.00;
      POCalcDetails.value.IGSTTaxAmount = 0.00;
      POCalcDetails.value.ItemCount = 0;
      POCalcDetails.value.TotalAmount = 0.00;
    }

    function TransportChargesOnChange() {
      debugger;
      POCalcDetails.value.Transportcharges = Number(requestForm.value.TransportCharges).toFixed(2)
      poSubcalculation();
    }

    function OtherChargesOnChange() {
      debugger;
      POCalcDetails.value.Othercharges = Number(requestForm.value.OtherCharges).toFixed(2)
      poSubcalculation();
    }

    function FreightChargesOnChange() {
      debugger;
      POCalcDetails.value.Freightcharges = Number(requestForm.value.Freightcharges).toFixed(2)
      poSubcalculation();
    }

    async function DiscountAmountOnChange() {
      debugger;
      POCalcDetails.value.DiscountAmount = 0.00;
      for (let i = 0; i < ItemTable.value.length; i++) {
        POCalcDetails.value.DiscountAmount += parseFloat(ItemTable.value[i]["DiscountAmount"]);
      }
      POCalcDetails.value.DiscountAmount = Number(Number(POCalcDetails.value.DiscountAmount) + Number(requestForm.value.DiscountAmount)).toFixed(2)
      poSubcalculation();
    }

    const IsSubmit = handleSubmit(async (values) => {
      debugger;
      SaveLoader.value = true;
      var FileUploadArray: any = [];
      if (ItemTable.value.length > 0) {

        if (SaveDraft.value == 0) {
          if (POCalcDetails.value.TotalAmount == MultiplePaymentList.value.reduce((sum, payment) => sum + Number(payment.Amount), 0).toFixed(2)) {
            toast.add({
              severity: "success",
              summary: "Success",
              detail: "PO amount matches the overall payment terms amount.",
              life: 3000,
            });
          }
          else {
            toast.add({
              severity: "warn",
              summary: "PO Amount Mismatch",
              detail: "The PO amount does not match the overall payment terms amount. Please review and correct the amounts.",
              life: 3000,
            });
            SaveLoader.value = false;
            return;
          }
        }

        requestForm.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        requestForm.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        requestForm.value.IsDraft = SaveDraft.value;
        requestForm.value.BranchId = Number(router.query.BranchId) ?? 0;
        requestForm.value.HospitalId = HospitalId;
        requestForm.value.ModifiedBy = UserId;
        requestForm.value.CreatedBy = UserId;
        requestForm.value.DocDate = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        requestForm.value.EntityId = POTypeEntityId.value;
        if (POTypeEntityId.value == 3077) {
          requestForm.value.EntityOperationId = 3077001
        }
        if (POTypeEntityId.value == 3078) {
          requestForm.value.EntityOperationId = 3078001
        }
        if (POTypeEntityId.value == 3079) {
          requestForm.value.EntityOperationId = 3079001
        }
        if (POTypeEntityId.value == 3129) {
          requestForm.value.EntityOperationId = 3129001
        }
        if (POTypeEntityId.value == 3149) {
          requestForm.value.EntityOperationId = 3149001
        }
        if (POTypeEntityId.value == 3150) {
          requestForm.value.EntityOperationId = 3150001
        }
        requestForm.value.DeptRoleId = rolesData.DeptRoleMapId;
        SupformData.value.BillingAddress = requestForm.value.BillingAddress;
        SupformData.value.AdditionalTerms = requestForm.value.AdditionalTerms;
        SupformData.value.Reference = requestForm.value.Reference;
        SupformData.value.SupplierId = !SupformData.value.SupplierId
          ? 0
          : SupformData.value.SupplierId;
        SupformData.value.PaymentTermsId = !SupformData.value.PaymentTermsId
          ? 0
          : SupformData.value.PaymentTermsId;
        SupformData.value.DeliveryTermsId = !SupformData.value.DeliveryTermsId
          ? 0
          : SupformData.value.DeliveryTermsId;
        SupformData.value.WarrantyTermsId = !SupformData.value.WarrantyTermsId
          ? 0
          : SupformData.value.WarrantyTermsId;
        requestForm.value.Id = Number(StockTransId) == 0 ? requestForm.value.Id : Number(StockTransId)
        await pocalculation();
        requestForm.value.TaxAmount = POCalcDetails.value.TaxAmount
        requestForm.value.SGSTTaxAmount = POCalcDetails.value.SGSTTaxAmount
        requestForm.value.CGSTTaxAmount = POCalcDetails.value.CGSTTaxAmount
        requestForm.value.IGSTTaxAmount = POCalcDetails.value.IGSTTaxAmount
        requestForm.value.Amount = POCalcDetails.value.TotalAmount
        requestForm.value.StoreId = Number(StoreId);
        requestForm.value.FromStore = Number(StoreId);
        requestForm.value.StoreBrMapId = Number(StoreBranchMapId);
        requestForm.value.FromStoreBranchId = Number(router.query.BranchId) ?? 0;
        requestForm.value.FromStoreBrMapId = Number(StoreBranchMapId);
        const form = Object.assign(requestForm.value, SupformData.value);
        let param = router.query.param;
        if (param == "PO") {
          requestForm.value.DocType = "4";
        } else if (param == "POAmendment") {
          requestForm.value.DocType = "6";
        }
        if (param == "PO") {
          if (id != "0") {
            id =
              id != "0"
                ? Number(id)
                : Number(id);
          }
          else {
            requestForm.value.Id = 0;
          }
        } else {
          requestForm.value.RefId = Number(POid);
          requestForm.value.Id = 0;
        }
        let StockDetailsId;
        debugger;
        for (let i = 0; i < ItemTable.value.length; i++) {
          let obj = {};
          if (
            (param == "PO" && StockTransId == 0 && DStockTransId == 0) ||
            (param == "POAmendment" && StockTransId != 0)
          ) {
            if (param == "POAmendment" && editSaveDraft.value == 1) {
              StockDetailsId = ItemTable.value[i]["StockDetailsId"];
            }
            if (param == "PO" && editSaveDraft.value == 1) {
              StockDetailsId = ItemTable.value[i]["StockDetailsId"];
            }
            else {
              StockDetailsId = 0;
            }
          } else if (
            param == "PO" &&
            (StockTransId != 0 || DStockTransId != 0)
          ) {
            StockDetailsId = ItemTable.value[i]["StockDetailsId"];
          }
          (obj["Id"] = StockDetailsId),
            (obj["ItemId"] = ItemTable.value[i]["ItemId"]),
            (obj["Qty"] = ItemTable.value[i]["ItemQuantity"]),
            (obj["RefId"] = id),
            (obj["PackSizeId"] = ItemTable.value[i]["PackSizeId"]),
            (obj["HSNId"] = ItemTable.value[i]["HSNId"]),
            (obj["UOM"] = ItemTable.value[i]["UOM"]),
            (obj["DiscountPer"] = ItemTable.value[i]["Discount"]),
            (obj["DiscountAmount"] = ItemTable.value[i]["DiscountAmount"]),
            (obj["PurchaseTax"] = ItemTable.value[i]["PurchasePercentage"]),
            (obj["PurchaseTaxAmount"] = ItemTable.value[i]["Purchasetaxamount"]),
            (obj["SGSTTax"] = ItemTable.value[i]["SGSTTax"]),
            (obj["SGSTTaxAmount"] = ItemTable.value[i]["SGSTTaxAmount"]),
            (obj["CGSTTax"] = ItemTable.value[i]["CGSTTax"]),
            (obj["CGSTTaxAmount"] = ItemTable.value[i]["CGSTTaxAmount"]),
            (obj["IGSTTax"] = ItemTable.value[i]["IGSTTax"]),
            (obj["IGSTTaxAmount"] = ItemTable.value[i]["IGSTTaxAmount"]),
            (obj["Amount"] = ItemTable.value[i]["Totalvalue"]),
            (obj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
            (obj["ModifiedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
            (obj["CreatedBy"] = UserId),
            (obj["ModifiedBy"] = UserId),
            (obj["Rate"] = ItemTable.value[i]["Rate"]),
            (obj["UnitRate"] = ItemTable.value[i]["UnitRate"]),
            (obj["Description"] = ItemTable.value[i]["Description"]),
            (obj["Brand"] =
              ItemTable.value[i]["Brand"] == null ? 0 : ItemTable.value[i]["Brand"]),
            (obj["ModelNumber"] =
              ItemTable.value[i]["ModelNumber"] == null
                ? 0
                : ItemTable.value[i]["ModelNumber"]),
            (obj["Size"] =
              ItemTable.value[i]["Size"] == null ? 0 : ItemTable.value[i]["Size"]);
          arr[i] = obj;
        }
        requestForm.value.StockWODetailList = arr
        let result = await commonService.createStockWODraft(requestForm.value);
        id = result["result"][0].Id
        requestForm.value.Id = id

        for (let i = 0; i < requestForm.value.StockWODetailList.length; i++) {
          const ResultList = result["result"][0]
          items.value[i].Id = ResultList.StockWODetailList[i]['Id'];
          items.value[i].StockDetailsId = ResultList.StockWODetailList[i]['Id'];
        }
        PoPaymentTermsDetails.value = []
        if (MultiplePaymentList.value.length != 0) {
          for (let i = 0; i < MultiplePaymentList.value.length; i++) {
            let PaymentTermsobj = {};
            if (MultiplePaymentList.value[i].PayTermsId != 0) {
              (PaymentTermsobj["Id"] = MultiplePaymentList.value[i].Id),
                (PaymentTermsobj["POId"] = requestForm.value.Id),
                (PaymentTermsobj["PayTermsId"] = MultiplePaymentList.value[i].PayTermsId),
                (PaymentTermsobj["Description"] = MultiplePaymentList.value[i].Description),
                (PaymentTermsobj["Percentage"] = Number(MultiplePaymentList.value[i].Percentage)),
                (PaymentTermsobj["Amount"] = Number(MultiplePaymentList.value[i].Amount)),
                (PaymentTermsobj["Days"] = Number(MultiplePaymentList.value[i].NoOfDays)),
                (PaymentTermsobj["Status"] = 0),
                (PaymentTermsobj["Storeid"] = Number(StoreId)),
                (PaymentTermsobj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
                (PaymentTermsobj["CreatedBy"] = UserId),
                (PaymentTermsobj["ModifiedBy"] = UserId),
                (PaymentTermsobj["ModifiedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
                (PaymentTermsobj["IsApproved"] = 1),
                (PaymentTermsobj["HospitalId"] = HospitalId),
                (PaymentTermsobj["BranchId"] = Number(router.query.BranchId) ?? 0),
                (PaymentTermsobj["PaymentTermsDesc"] = ''),
                (PaymentTermsobj["FileUpload"] = ''),
                (PaymentTermsobj["Initiate"] = false)
              PoPaymentTermsDetails.value.push(PaymentTermsobj)
            }

          }
          let FileUploadResult = await POPaymentTermsDetailsServices.insert(PoPaymentTermsDetails.value);
        }
        if (uploadedTableList.value.length != 0) {
          for (let i = 0; i < uploadedTableList.value.length; i++) {
            let Fileobj = {};
            (Fileobj["Id"] = uploadedTableList.value[i].Id),
              (Fileobj["DocType"] = requestForm.value.DocType),
              (Fileobj["RefId"] = requestForm.value.Id),
              (Fileobj["FileName"] = uploadedTableList.value[i].fileName),
              (Fileobj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (Fileobj["CreatedBy"] = UserId),
              (Fileobj["ModifiedBy"] = 0),
              (Fileobj["EntityId"] = Number(Entitydata.value)),
              (Fileobj["IsApproved"] = 0),
              FileUploadArray.push(Fileobj)
          }
          StockWOFileUpload.value = FileUploadArray
          let FileUploadResult = await StockWOFileUploadServices.insertStockWOFile(StockWOFileUpload.value);
        }
        if (DeletedFileUpload.length > 0) {
          debugger
          let result = await StockWOFileUploadServices.DeleteList(DeletedFileUpload.join(','));
        }
        loading.value = false
        SaveFlag.value = true;
        if (param == "PO" && result["ErrorInfo"].ErrorCode == null) {
          if (SaveFlag.value == true) {
            if (StockTransId != "0") {

              if (SaveDraft.value == 1) {
                alert(
                  "your data has been saved for future editing. You can continue to work on your submission later."
                );
                closetrigger();
              }
              else {
                updatepop.value = true;

              }

            } else {
              PrintCrystalReport(id, result["result"][0].BranchId, result["result"][0].HospitalId);
              successpop.value = true;
              SaveLoader.value = false;
            }
          }


        } else if (param == "POAmendment" && result["ErrorInfo"].ErrorCode == null) {
          successpop.value = true;
          SaveLoader.value = false;
        }
        else {
          alert("Somthing went wrong")
          SaveLoader.value = false;
        }
        // }
        // else {
        //   toast.add({
        //     severity: "warn",
        //     summary: "PO Amount Mismatch",
        //     detail: "The PO amount does not match the overall payment terms amount. Please review and correct the amounts.",
        //     life: 3000,
        //   });
        //   SaveLoader.value = false;
        // }
      } else {
        toast.add({
          severity: "warn",
          summary: "Item Required",
          detail: "Please add an item before proceeding.",
          life: 3000,
        });
        SaveLoader.value = false;
      }
    })

    //ReOrder Level Table
    async function LoadReOrderLevel() {
      debugger;
      let result = await commonService.GetReOrderLevelList(StoreId, session.OrganizationId, session.BranchId);
      result = result["result"];

      ReOrderData.value = result;
    }

    function ReOrderItemSelect(value) {
      debugger;
      selectedProduct.value = value;

      console.log(selectedProduct.value);
    }

    function AddSingleConfirmation(val) {
      debugger;
      confirmval.value = val;
      if (ReOrderData.value == "") {
        warningmsgcontent.value.warningcontent = t('confirmation.thereisnoitems');
        wariningPopup.value = true;
      } else if (selectedProduct.value == "" || selectedProduct.value == null) {
        warningmsgcontent.value.warningcontent = t('confirmation.pleaseselecttheitems');
        wariningPopup.value = true;
      } else {
        msgcontent.value.contentvalue =
          t('confirmation.doyouwantaddselecteditemstorequest');
        AddItemmodel.value = true;
      }
    }

    function AddAllConfirmation(val) {
      debugger;
      confirmval.value = val;
      if (ReOrderData.value == "") {
        warningmsgcontent.value.warningcontent = t('confirmation.thereisnoitems');
        wariningPopup.value = true;
      } else {
        msgcontent.value.contentvalue =
          t('confirmation.doyouwantaddselecteditemstorequest');
        AddItemmodel.value = true;
      }
    }

    function ClosewariningPopup() {
      debugger;
      wariningPopup.value = false;
    }

    let CopiedReOrderData: any = ref([]);
    let RemoveReOrderItems: any = ref([]);

    function CopyReorderData() {
      debugger;
      if (ItemTable.value.length > 0) {
        Object.values(ItemTable.value).forEach((x: any) => {
          Object.values(selectedProduct.value).forEach((y: any) => {
            if (y.ReOrderLevel != 0) {
              if (
                x.ItemId === y.ItemId &&
                x.Brand === y.Brand &&
                x.ModelNumber === y.ModelNumber &&
                x.Size === y.Size
              ) {
                // Update item properties based on selectedProduct
                x.UOM = y.UOM;
                x.UOMName = y.UOMName;
                x.PackSizeId = y.PackSizeId;
                x.PackSizename1 = y.PackSizename1;
                x.PackSizeQty = y.PackSizeQty;
                x.ItemQuantity = y.ReOrderLevel;
                x.UnitRate = Number(y.UnitRate).toFixed(2);
                x.Rate = Number(x.ItemQuantity * x.UnitRate).toFixed(2);

                x.Purchasetaxamount = Number((x.PurchasePercentage * x.Rate) / 100).toFixed(2);

                if (session.BranchStateId != SupformData.value.SupllierStateId) {
                  x.SGSTTax = 0;
                  x.SGSTTaxAmount = 0.0;

                  x.CGSTTax = 0;
                  x.CGSTTaxAmount = 0.0;

                  x.IGSTTax = Number(x.PurchasePercentage);
                  x.IGSTTaxAmount = Number((x.PurchasePercentage * x.Rate) / 100).toFixed(2);
                } else {
                  x.SGSTTax = Number(x.PurchasePercentage) / 2;
                  x.SGSTTaxAmount = Number(Number(x.Purchasetaxamount) / 2).toFixed(2);

                  x.CGSTTax = Number(x.PurchasePercentage) / 2;
                  x.CGSTTaxAmount = Number(Number(x.Purchasetaxamount) / 2).toFixed(2);

                  x.IGSTTax = 0;
                  x.IGSTTaxAmount = 0.0;
                }

                x.Amount = Number(
                  Number(x.Rate) +
                  Number(x.SGSTTaxAmount) +
                  Number(x.CGSTTaxAmount) +
                  Number(x.IGSTTaxAmount)
                ).toFixed(2);

                RemoveReOrderItems.value.push(y);
              } else {
                // Check if the item already exists in CopiedReOrderData to avoid duplicates
                const existingItem = CopiedReOrderData.value.find((item: any) =>
                  item.ItemId === y.ItemId &&
                  item.Brand === y.Brand &&
                  item.ModelNumber === y.ModelNumber &&
                  item.Size === y.Size
                );

                if (!existingItem) {
                  CopiedReOrderData.value.push(y);
                  RemoveReOrderItems.value.push(y);
                }
              }
            }
          });
        });

        if (CopiedReOrderData.value.length > 0) {
          const mappedItems = CopiedReOrderData.value.map((item) => {
            item.UOM = item.PurchaseUnit;
            item.UOMName = item.PurchaseUnitName;
            item.ItemQuantity = item.ReOrderLevel;
            item.UnitRate = Number(item.UnitRate).toFixed(2);
            item.Rate = Number(item.ItemQuantity * item.UnitRate).toFixed(2);

            item.Purchasetaxamount = Number((item.PurchasePercentage * item.Rate) / 100).toFixed(2)

            if (session.BranchStateId != SupformData.value.SupllierStateId) {
              item.SGSTTax = 0;
              item.SGSTTaxAmount = 0.00;

              item.CGSTTax = 0;
              item.CGSTTaxAmount = 0.00;

              item.IGSTTax = Number(item.PurchasePercentage)
              item.IGSTTaxAmount = Number((item.PurchasePercentage * item.Rate) / 100).toFixed(2)
            }
            else {
              item.SGSTTax = Number(item.PurchasePercentage) / 2
              item.SGSTTaxAmount = Number(Number(item.Purchasetaxamount) / 2).toFixed(2)

              item.CGSTTax = Number(item.PurchasePercentage) / 2
              item.CGSTTaxAmount = Number(Number(item.Purchasetaxamount) / 2).toFixed(2)

              item.IGSTTax = 0;
              item.IGSTTaxAmount = 0.00;
            }

            item.Amount = Number(Number(item.Rate) + Number(item.SGSTTaxAmount) +
              Number(item.CGSTTaxAmount) + Number(item.IGSTTaxAmount)).toFixed(2);

            return item;
          });

          // Push each mapped item to ItemTable.value
          mappedItems.forEach((item) => {
            ItemTable.value.push(item);
          });
        }
      }
      else {

        Object.values(selectedProduct.value).forEach((y: any) => {
          if (y.ReOrderLevel != 0) {
            CopiedReOrderData.value.push(y);
            RemoveReOrderItems.value.push(y);
          }
        });

        if (CopiedReOrderData.value.length > 0) {
          const mappedItems = CopiedReOrderData.value.map((item) => {

            item.UOM = item.PurchaseUnit;
            item.UOMName = item.PurchaseUnitName;
            item.ItemQuantity = item.ReOrderLevel;
            item.UnitRate = Number(item.UnitRate).toFixed(2);
            item.Rate = Number(item.ItemQuantity * item.UnitRate).toFixed(2);

            item.Purchasetaxamount = Number((item.PurchasePercentage * item.Rate) / 100).toFixed(2)

            if (session.BranchStateId != SupformData.value.SupllierStateId) {
              item.SGSTTax = 0;
              item.SGSTTaxAmount = 0.00;

              item.CGSTTax = 0;
              item.CGSTTaxAmount = 0.00;

              item.IGSTTax = Number(item.PurchasePercentage);
              item.IGSTTaxAmount = Number((item.PurchasePercentage * item.Rate) / 100).toFixed(2);
            }
            else {
              item.SGSTTax = Number(item.PurchasePercentage) / 2;
              item.SGSTTaxAmount = Number(Number(item.Purchasetaxamount) / 2).toFixed(2);

              item.CGSTTax = Number(item.PurchasePercentage) / 2;
              item.CGSTTaxAmount = Number(Number(item.Purchasetaxamount) / 2).toFixed(2);

              item.IGSTTax = 0;
              item.IGSTTaxAmount = 0.00;
            }

            item.Amount = Number(Number(item.Rate) + Number(item.SGSTTaxAmount) +
              Number(item.CGSTTaxAmount) + Number(item.IGSTTaxAmount)).toFixed(2);

            return item;
          })

          // Push each mapped item to ItemTable.value
          mappedItems.forEach((item) => {
            ItemTable.value.push(item);
          });
        }
      }

      if (RemoveReOrderItems.value.length > 0) {
        ReOrderData.value = ReOrderData.value.filter((x: any) => {
          return !Object.values(RemoveReOrderItems.value).some((y: any) => {
            return (
              x.ItemId === y.ItemId &&
              x.Brand === y.Brand &&
              x.ModelNumber === y.ModelNumber &&
              x.Size === y.Size
            );
          });
        });
      }

      const hasZeroQuantity = selectedProduct.value.some(item => item.ReOrderLevel === 0);

      items.value = ItemTable.value;
      CopiedReOrderData.value = [];
      RemoveReOrderItems.value = [];
      selectedProduct.value = [];
      AddItemmodel.value = false;

      if (hasZeroQuantity) {
        toast.add({
          severity: "warn",
          summary: "Item Quantity Error",
          detail: "One or more items have a quantity of 0. Please check the items.",
          life: 3000,
        });
        return;
      }
      else {
        clases.value.ItemsReOrderTab = 0;
      }

    }
    let calcValues = ref({
      grossamount: 0.0,
    });

    function SupplierValue(data) {
      if (data) {
        debugger;
        commonItemProps.value.supplierId = data.SupplierId;
        commonItemProps.value.SupllierStateId = data.StateId;
        SupformData.value.PaymentTermsId = data.PaymentTermsId;
        SupformData.value.DeliveryTermsId = data.DeliveryTermsId;
        SupformData.value.Email = data.Email;
        SupformData.value.SupllierCountryId = data.CountryId;
        SupformData.value.SupllierStateId = data.StateId;
        SupformData.value.SupllierCityId = data.CityId;
        if (IsSupEdit.value == 0) {
          requestForm.value.AdditionalTerms = data.AdditionalTerms;
          requestForm.value.SupplierAddress = data.BillingAddress;
          requestForm.value.Reference = data.Reference;
        }
      }
    }

    function PrintCrystalReport(Id, BranchId, HospitalId) {
      debugger;
      // Set parameters
      ParameterValues.value.Id = Id;
      ParameterValues.value.BranchId = BranchId;
      ParameterValues.value.HospitalId = HospitalId;

      // Set type to "S" to directly open in new tab
      PrintType.value.Type = "S";

      // Make sure popup doesn't show
      CrystalReportPopup.value = true;

      // Still send email as before
      ExportSendMail();
    }

    const EditSupplierAddress = () => {
      debugger;
      editsupplieraddress.value = !editsupplieraddress.value;
      // Focus the textarea
      const textarea = document.getElementById("billingTextarea");
      if (textarea) {
        textarea.focus();
      }
    };

    const EditDeliveryAddress = () => {
      debugger;
      editdeliaddress.value = !editdeliaddress.value;

      const textarea = document.getElementById("billingTextarea");
      if (textarea) {
        textarea.focus();
      }
    };

    const EdiBillAddress = () => {
      debugger;
      editbillingaddress.value = !editbillingaddress.value;
      const textarea = document.getElementById("billingTextarea");
      if (textarea) {
        textarea.focus();
      }
    };

    const SaveEditBillAddress = () => {
      editsupplieraddress.value = false;
    };



    async function GetStoresByUserId() {
      debugger;

      // const result = await StoreService.getStoreListByUserId(
      //   session.UserId,
      //   session.OrganizationId,
      //   session.Admin,
      //   router.query.BranchId ?? 0,
      // );

      const result = await StoreService.StoreDropDownListByUserId(
        session.UserId,
        session.OrganizationId,
        session.Admin,
        router.query.BranchId ?? 0,
      );

      if (result["result"].length > 0) {
        let StoreData = result["result"].find(
          (item) => item.Id == StoreId && item.StoreBranchMapId == StoreBranchMapId && item.BranchId == Number(router.query.BranchId ?? 0),
        );

        requestForm.value.BillingAddress = StoreData?.BranchAddress;
      }
    }

    let StoreArray: any = ref([]);
    let StoreObj = ref()

    const StoreOptionsFun = (data) => {
      if (data) {
        StoreArray.value = data

        // StoreObj.value = StoreArray.value.find(
        //   store => store.Id == StoreId && store.BranchId == router.query.BranchId)

        StoreObj.value = StoreArray.value.find(
          store => store.Id == requestForm.value.ToStore || StoreId && store.BranchId == requestForm.value.ToStoreBranchId || router.query.BranchId)

        SelectStore(StoreObj.value)
        StoreOnChange(StoreObj.value)
      }
    }

    async function StoreOnChange(data) {
      debugger;
      try {
        if (data.Id) {
          let branchid = "0";
          const result = await StoreService.getStoreByStoreId(
            StoreId,
            session.OrganizationId,
            branchid
          );
          if (result["result"].length > 0) {
            let StoreData = result["result"].find(
              (item) => item.Id == data.Id && item.StoreBranchMapId == data.StoreBranchMapId && item.BranchId == data.BranchId
            );

            requestForm.value.DeliveryAddress = StoreData?.BranchAddress;
          }
        }

      } catch (error) {
        console.log(error);
      }
    }

    let supplierDetailsList = ref([])
    async function getSupplierDetailsItemId(data) {
      try {
        const result = await WithoutStockAffectService.GetSupplierDetailsByItemId(data.ItemId, data.Brand, data.ModelNumber, data.Size, data.UOM);
        console.log(result);
        supplierDetailsList.value = result["result"];
      } catch (error) {
        console.log(error);
      }
    }
    async function ExportSendMail() {
      try {
        debugger;
        let obj = {
          FormId: 14,
          ModuleId: 3,
          OrganizationId: HospitalId,
          BranchId: Number(router.query.BranchId ?? 0),
          JsonValue: "{ id:" + ParameterValues.value.Id + "}",
          FileName: "PO" + ParameterValues.value.Id,
          PathView: "PO",
          DeptRoleId: DeptRoleMapId,
          EntityTransactionId: ParameterValues.value.Id,
          EntityOperationId: OperationId,
          Email: SupformData.value.Email,
          SupplierName: SupformData.value.SupplierName,
          DeliveryAddress: SupformData.value.BillingAddress,
          ItemList: itemslist.value,
          UserId: usersData.UserId,
          UserName: usersData.UserName,
          ContactAddress: usersData.AddressVar,
          PhoneNumber: usersData.phoneNumber,
          Position: rolesData.RoleName
        };
        const result = await commonService.ExportSendMail(obj);
        console.log(result);
      } catch (error) {
        console.log(error);
      }
    }

    function IsDraftSubmit(Type) {
      debugger;
      SaveDraft.value = Type;
      IsSubmit();
    }

    function PrintPreCrystalReport() {
      debugger;
      PrintType.value.Type = "T";
      CrystalReportPopup.value = true;
      ParameterValues.value.Id = DStockTransId;
    }


    function ExcelDataImport(ExcelData) {
      debugger;
      ExcelResponse.value = ExcelData;
      const mappedData = ExcelResponse.value.map((item) => {
        const mappedItem = {};
        Object.entries(item).forEach(([key, value]) => {
          const normalizeString = str => str.replace(/\s/g, '').toLowerCase();
          const header = headers.find(header => normalizeString(header.header) === normalizeString(key));

          if (header && header.field) {
            mappedItem[header.field] = value;
          }
        });
        return mappedItem;
      });
      ItemTable.value = [...ItemTable.value, ...mappedData];
    }
    function clearItems(value1) {
      debugger;
      dataItems.value = {}

    }

    // function ItemUpdated() {
    //   if (EditFlag == 1) {
    //     SaveFlag.value = false;
    //     if (router.query.param != "POAmendment") {
    //       SaveDraft.value = 1;
    //       IsSubmitDraft()
    //     }
    //   }
    // }

    // function ItemUpdated(data) {
    //   if (EditFlag == 1) {
    //     SaveFlag.value = false;
    //     if (router.query.param != "POAmendment") {
    //       SaveDraft.value = 1;
    //       for (let item of ItemTable.value) {
    //         dupitems.value.push(item)
    //       }
    //       IsSubmitDraft()
    //     }
    //   }
    // }

    function ItemUpdated(data) {
      if (EditFlag == 1) {
        SaveFlag.value = false;
        if (router.query.param != "POAmendment") {
          SaveDraft.value = 1;
          // Only push the edited item to dupitems
          const editedItem = ItemTable.value.find(item => {
            // if (!dataItems.value || typeof dataItems.value !== 'object') return false;
            // return item.ItemId === (dataItems.value as any).ItemId &&
            //   item.Brand === (dataItems.value as any).Brand &&
            //   item.ModelNumber === (dataItems.value as any).ModelNumber &&
            //   item.Size === (dataItems.value as any).Size;
            if (!HiddenEditData.value || typeof HiddenEditData.value !== 'object') return false;
            return item.ItemId === (HiddenEditData.value as any).ItemId &&
              item.Brand === (HiddenEditData.value as any).Brand &&
              item.ModelNumber === (HiddenEditData.value as any).ModelNumber &&
              item.Size === (HiddenEditData.value as any).Size;
          });
          if (editedItem) {
            dupitems.value = [editedItem];
          }
          IsSubmitDraft();
        }
      }
    }

    const handleChangedocument = async (event: Event) => {
      debugger;
      debugger;
      let result;
      let files: any = ''
      const input = event.target as HTMLInputElement;
      files = input['files'];
      console.log(files);
      if (files && files.length > 0) {
        debugger;
        for (let i = 0; i < files.length; i++) {
          let form = new FormData();
          console.log(files[i]);
          form.append("file", files[i]);
          console.log(form);
          result = await common.uploadquotation(form, 'TransactionFiles');
          console.log('Uploaded :', result);
          let ResponseValue = result;
          ResponseValue['Id'] = 0
          fullPath.value = result.uploadPath
          uploadedTableList.value.push(ResponseValue)
        }
      }
      debugger
      console.log(uploadedTableList.value)
    };
    function fileviewer(data) {
      debugger
      const newTabUrl = data;
      window.open(newTabUrl, '_blank');
    }
    const fileuploadDelete = async (data) => {
      DeletedFileUpload.push(data.Id)
      uploadedTableList.value = uploadedTableList.value.filter((item) => item.fileName != data.fileName)
      if (DeletedFileUpload.length > 0 && IsDraftFlag == 1) {
        debugger
        let result = await StockWOFileUploadServices.DeleteList(DeletedFileUpload.join(','));
      }
    }
    let deletedPaymentList = ref()
    let MultiplePaymentList = ref()
    function MultiplePayment(value) {
      MultiplePaymentList.value = value
    }
    async function deletedPayment(value) {
      if (IsDraftFlag == 1) {
        if (value.length > 0) {
          debugger
          let result = await POPaymentTermsDetailsServices.deletedata(value.join(','));
        }
      }
      else {
        deletedPaymentList.value = value
      }
    }

    function DeleteSupplier() {
      debugger;
      requestForm.value.SupplierAddress = "";
    }

    const TempTaxOption = [
      { value: 5, name: '5%' },
      { value: 9, name: '9%' },
      { value: 12, name: '12%' },
      { value: 18, name: '18%' },
    ];


    function TempTaxOnChange(data) {
      debugger;

      data.Purchasetaxamount = (data.Rate * (data.PurchasePercentage / 100)).toFixed(2);

      if (data.SGSTTax && data.CGSTTax) {

        data.SGSTTax = Number(data.PurchasePercentage) / 2;

        data.SGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);

        data.CGSTTax = Number(data.PurchasePercentage) / 2;

        data.CGSTTaxAmount = Number(Number(data.Purchasetaxamount) / 2).toFixed(2);
      }

      if (data.IGSTTax) {
        data.CGSTTax = Number(data.PurchasePercentage) / 2;
        data.IGSTTaxAmount = Number((data.PurchasePercentage * data.Rate) / 100).toFixed(2);
      }

      data.Totalvalue = Number((Number(data.Rate) - Number(data.DiscountAmount)) + Number(data.Purchasetaxamount)).toFixed(2)
    }

    return {
      clearItems,
      CopiedReOrderData,
      codeStatus,
      supplierDetailsList,
      getSupplierDetailsItemId,
      Iteminfoheaders,
      visible,
      StoreId,
      editSaveDraft,
      route,
      PrintPreCrystalReport,
      IsSupEdit,
      StoreOnChange,
      changeval,
      consumeOrService,
      todayDate,
      dataItems,
      IsItemEdit,
      IsItemDelete,
      alreadyclosetrigger,
      closetrigger,
      alreadyexistpop,
      updatepop,
      successpop,
      showFields,
      LoadPoDocNo,
      SupformData,
      AddItems,
      GetCode,
      List,
      requestForm,
      IsSubmit,
      showitemfield,
      ShowItems,
      globalFilterFields,
      filters,
      items,
      headers,
      loading,
      SaveLoader,
      paramValue,
      commonItemProps,
      ReOrderheaders,
      ReOrderData,
      selectedProduct,
      AddItemmodel,
      CopyReorderData,
      wariningPopup,
      warningmsgcontent,
      msgcontent,
      confirmval,
      ClosewariningPopup,
      AddSingleConfirmation,
      AddAllConfirmation,
      Codes,
      CodesRef,
      TotalGrossCalc,
      calcValues,
      SupplierValue,
      SupplierDropDownDisable,
      CrystalReportPopup,
      ParameterValues,
      PrintType,
      StoreDropdown,
      StoreDropdownDisable,
      DocNoObj,
      billingaddress,
      editsupplieraddress,
      EditSupplierAddress,
      SaveEditBillAddress,
      newbillingaddress,
      editdeliaddress,
      editsuppaddress,
      EditDeliveryAddress,
      IsDraftSubmit,
      ExcelDataImport,
      editbillingaddress,
      EdiBillAddress,
      menuarray,
      POCalcDetails,
      TransportChargesOnChange,
      OtherChargesOnChange,
      DiscountAmountOnChange,
      FreightChargesOnChange,
      itemslist,
      StoreModel,
      SelectStore,
      goToFirstPage,
      ReOrderItemSelect,
      clases,
      ItemTable,
      ItemUpdated,
      handleChangedocument,
      uploadedTableList,
      fileviewer,
      fileuploadDelete,
      MultiplePayment,
      MultiplePaymentList,
      deletedPaymentList,
      deletedPayment,
      ItemDeleteConfirm,
      StoreOptionsFun,
      loadingforms,
      DeleteSupplier,

      // temp tax changes
      TempTaxOption,
      TempTaxOnChange,
      IsSubmitDraft
    };
  },
});
</script>
<style lang="scss">
@media only screen and (max-width: 1980px) and (min-width: 1400px) {
  .container-class {
    max-width: 90% !important;
  }
}

.poaction {
  display: flex;
  align-items: center;
  gap: 10px;

  .addbtn {
    padding: 14px 20px !important;
  }
}
</style>

<style lang="scss" scoped>
.contentbg {
  background-color: #f5f5f5;
  padding: 10px;
  font-size: 14px;
  color: #999999;
}

.saveasdraft {
  position: absolute;
  right: 147px;
  bottom: 12px;
}

.savedraftbtn {
  border: 1px solid #999999;
  padding: 10px 15px;
  width: max-content;
  border-radius: 5px;
  background-color: #ffffff;

  p {
    color: #999999;
  }
}

.p-dialog .p-dialog-header .p-dialog-header-icon {
  display: none !important;
}
</style>
